import React from 'react';
import styled from 'styled-components';
import { animated, Spring } from 'react-spring';
import { inject, observer } from 'mobx-react';

import ImageUploader from 'js/components/core/ImageUploader';

const Container = animated(styled.div`
  float: left;
  width: 60px;
  border: none;
  text-align: left;
`);

export default inject('page')(
  observer(({ page, style }) => {
    const image = page.primary_image;
    return (
      <Container style={style}>
        <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
          {animation => (
            <animated.div style={animation}>
              <ImageUploader image={image} setError={page.setError} onUpload={page.onUpload} size="3.75rem" />
            </animated.div>
          )}
        </Spring>
      </Container>
    );
  }),
);
